/* eslint-disable import/prefer-default-export */
import { UPDATE_PRODUCT_FILTERS } from './types';

export const updateProductFilters = (update) => ({
  type: UPDATE_PRODUCT_FILTERS,
  payload: update,
});
